import { graphql } from "../gql";

export const deleteAuditRuleMutationDoc = graphql(`
  mutation uiDeleteRuleV2($id: String!) {
    uiDeleteRuleV2(id: $id)
  }
`);
